import { Menu } from '@mui/material';
import styled from 'styled-components';
import { glassSurface } from './GlassSurface';

export const GlassMenu = styled(Menu)`
  & .MuiPaper-root {
    ${glassSurface};
  }
`;
